import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'

export const ClassificationView = () => {
  return <SettingsPage title="Classification" />
}
